import type { CSSProperties } from "react";

export const formItemSharedStyles: CSSProperties = { marginBottom: "5px" };
